import moment from "moment";
import {Inertia} from "@inertiajs/inertia";

export const DATE_REGEX = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;

const fraction = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const formatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

export function prettifyStepValue(value){
  if (value === null) return value;
  if (typeof value == "boolean") {
    return value ? 'oui' : 'non';
  }
  if (typeof value == "number") {
    return value;
  }
  if (value.match(DATE_REGEX)){
    return moment(value).format('L');
  }
  return value;
}


export function addScript(id, url){
  if (document.getElementById(id)) return false;
  const scripts_div = document.getElementById('dynamic-scripts')
  const script = document.createElement('script');
  script.src = url;
  script.id = id;
  scripts_div.append(script);
}


export function formatNumber(integer, digitsCount){
  if (!integer) return '0';
  return `${integer}`.padStart(digitsCount, '0');
}


export function officeRoute(routename, params={}){
  return route(routename, {
    officeMatricule: Inertia.page.props.current_office.matricule,
        ...params
  });
}

export function validateSiret(siret){
  return siret.match(/^[0-9]{14}$/)
}

export function validateMatricule(matricule){
  return matricule.match(/^[0-9]{8}$/)
}

export function formatDate(date){
  if (!date) return date;
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString('fr-FR');
}

export function debug(text){
  if (process.env.NODE_ENV === 'development'){
    console.log('%cDebug: %c'+text, 'color:orange; font-wigth:bold', '');
  }
}

export function ucfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatCurrency(amount) {
  if(amount % 1 == 0)
    return fraction.format(amount)
  else
    return formatter.format(amount)
}

export function mapServerFormFields(fields, initialData = {}){
  const formParams = {};

  const mapField = (field) => {
    if (field.type === 'fieldset'){
      for (let _field of field.fields) mapField(_field);
    } else if (field.type === 'phone'){
      formParams[ field.name ] = initialData[ field.name ];
      formParams[ field.identifierName ] = initialData[ field.identifierName ];
    } else if (field.type === 'file-list-upload'){
      formParams[ field.name ] = [];
      formParams[ field.checkboxesName ] = initialData[ field.checkboxesName ];
    } else {
      formParams[ field.name ] = initialData[ field.name ];
    }
  }

  for (let field of fields){
    mapField(field)
  }

  return formParams;
}

export function dateIsThisMonth(date){
  console.log(date);
  const todaysDate = new Date();
  return (todaysDate.getMonth() === date.getMonth()) && (todaysDate.getFullYear() === date.getFullYear())
}

export function dateIsPreviousMonth(date){
  const todaysDate = new Date();
  let lastMonth = todaysDate.getMonth()-1;
  let year = todaysDate.getFullYear();
  if (lastMonth < 0) {
    lastMonth = 11;
    year = year-1;
  }
  return (lastMonth === date.getMonth()) && (year === date.getFullYear())
}
